// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import ExistingTimelineComponent from "./ExistingTimelineComponent";
// import FormComponent from "./FormComponent";
// import { useLocation } from "react-router-dom";
// import {
//   Alert,
//   Box,
//   Card,
//   CardContent,
//   Grid,
//   Snackbar,
//   Typography,
// } from "@mui/material";
// import CallerComponent from "../../Dialer/callerComponent";
// import {
//   FISH_FEED_INCOMMING_CALL,
//   FISH_FEED_OUTGOING_CALL,
//   SHRIMP_LISTING_MASTER,
// } from "../../../constants";

// // Utility to get date string in YYYY-MM-DD
// const getFormattedDate = (date) => date.toISOString().split("T")[0];

// const SummaryCard = ({ title, value, subtext }) => (
//   <Card
//     sx={{
//       borderRadius: 4,
//       padding: 2,
//       textAlign: "center",
//       boxShadow: "0 2px 12px rgba(0,0,0,0.1)",
//       backgroundColor: "#fff",
//       height: "100%",
//     }}
//   >
//     <Typography variant="subtitle1" fontWeight="bold" color="text.secondary">
//       {title}
//     </Typography>
//     <Typography variant="h4" color="primary" fontWeight="bold" mt={1} mb={1}>
//       {value}
//     </Typography>
//     {subtext && (
//       <Typography variant="caption" color="text.secondary">
//         {subtext}
//       </Typography>
//     )}
//   </Card>
// );

// const FishFeedDashboardComponent = () => {
//   const [tableMobile, setTableMobile] = useState("");
//   const [formOpen, setFormOpen] = useState(false);
//   const [FormMobileNo, setFormMobileNo] = useState("");
//   const [openSnackbar, setOpenSnackbar] = useState(false);
//   const [severity, setSeverity] = useState("");
//   const [message, setMessage] = useState("");
//   const [callID, setCallID] = useState("");
//   const [callType, setCallType] = useState("");
//   const [missedCallID, setMissdeCalID] = useState("");
//   const [auditMobNum, setAuditMobNum] = useState("");

//   const [incoming, setIncoming] = useState(null);
//   const [outgoing, setOutgoing] = useState(null);
//   const [shrimp, setShrimp] = useState(null);

//   const location = useLocation();
//   const { mobNo } = location.state || {};

//   const endDate = getFormattedDate(new Date());
//   const startDate = getFormattedDate(
//     new Date(new Date().setDate(new Date().getDate() - 6))
//   );
//   const agent = JSON.parse(localStorage.getItem("userData"));
//   const agentNumber = agent?.EmployeePhone;

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const [incomingRes, outgoingRes, shrimpRes] = await Promise.all([
//           axios.get(
//             `${FISH_FEED_INCOMMING_CALL}?startDate=${startDate}&endDate=${endDate}&agentNumber=${agentNumber}`
//           ),
//           axios.get(
//             `${FISH_FEED_OUTGOING_CALL}?startDate=${startDate}&endDate=${endDate}&aPartyNo=${agentNumber}`
//           ),
//           axios.get(`${SHRIMP_LISTING_MASTER}`),
//         ]);
//         setIncoming(incomingRes.data);
//         setOutgoing(outgoingRes.data);
//         setShrimp(shrimpRes.data);
//       } catch (error) {
//         console.error(error);
//         setMessage("Error loading dashboard data");
//         setSeverity("error");
//         setOpenSnackbar(true);
//       }
//     };

//     fetchData();
//   }, []);

//   const handleCloseSnackbar = (event, reason) => {
//     if (reason === "clickaway") return;
//     setOpenSnackbar(false);
//   };

//   return (
//     <>
//       <Grid container spacing={2} style={{ flexWrap: "wrap" }}>
//         {formOpen ? (
//           <>
//             <Grid item xs={12} sm={5} md={5} style={{ flexGrow: 1 }}>
//               <ExistingTimelineComponent FormMobileNo={FormMobileNo} />
//             </Grid>
//             <Grid
//               item
//               xs={12}
//               sm={4}
//               md={4}
//               style={{ flex: "1 1 350px", minWidth: "300px" }}
//             >
//               <FormComponent
//                 setFormOpen={setFormOpen}
//                 setOpenSnackbar={setOpenSnackbar}
//                 setSeverity={setSeverity}
//                 setMessage={setMessage}
//                 FormMobileNo={FormMobileNo}
//                 callID={callID}
//                 callType={callType}
//               />
//             </Grid>
//           </>
//         ) : (
//           <>
//             <Grid item xs={12} md={8}>
//               <Box sx={{ mb: 1 }}>
//                 <Typography variant="h5" fontWeight="bold">
//                   Fish Feed Dashboard
//                 </Typography>
//                 <Typography variant="body2" color="text.secondary">
//                   Past 7 Days: <strong>{startDate}</strong> to{" "}
//                   <strong>{endDate}</strong>
//                 </Typography>
//               </Box>

//               <Grid container spacing={2}>
//                 {incoming && (
//                   <>
//                     <Grid item xs={12} sm={6} md={3}>
//                       <SummaryCard
//                         title="Incoming Calls"
//                         value={incoming.summary.totalCalls}
//                       />
//                     </Grid>
//                     <Grid item xs={12} sm={6} md={3}>
//                       <SummaryCard
//                         title="Connected (In)"
//                         value={incoming.summary.connectedCalls}
//                         subtext={`Rate: ${incoming.summary.connectionRate}`}
//                       />
//                     </Grid>
//                     <Grid item xs={12} sm={6} md={3}>
//                       <SummaryCard
//                         title="Missed (In)"
//                         value={incoming.summary.missedCalls}
//                       />
//                     </Grid>
//                     <Grid item xs={12} sm={6} md={3}>
//                       <SummaryCard
//                         title="Duration (In)"
//                         value={incoming.summary.totalDuration}
//                       />
//                     </Grid>
//                   </>
//                 )}
//                 {outgoing && (
//                   <>
//                     <Grid item xs={12} sm={6} md={3}>
//                       <SummaryCard
//                         title="Outgoing Calls"
//                         value={outgoing.summary.totalCalls}
//                       />
//                     </Grid>
//                     <Grid item xs={12} sm={6} md={3}>
//                       <SummaryCard
//                         title="Connected (Out)"
//                         value={outgoing.summary.connectedCalls}
//                         subtext={`Rate: ${outgoing.summary.connectionRate}`}
//                       />
//                     </Grid>
//                     <Grid item xs={12} sm={6} md={3}>
//                       <SummaryCard
//                         title="Missed (Out)"
//                         value={outgoing.summary.missedCalls}
//                       />
//                     </Grid>
//                     <Grid item xs={12} sm={6} md={3}>
//                       <SummaryCard
//                         title="Duration (Out)"
//                         value={outgoing.summary.totalDuration}
//                       />
//                     </Grid>
//                   </>
//                 )}
//               </Grid>

//               <Box mt={4}>
//                 <Typography variant="h6" fontWeight="bold">
//                   Shrimp Feed Details
//                 </Typography>
//                 <Grid container spacing={2} mt={1}>
//                   {shrimp && (
//                     <Grid item xs={12} sm={6} md={3}>
//                       <SummaryCard
//                         title="Total Records"
//                         value={shrimp.data.totalCount}
//                       />
//                     </Grid>
//                   )}
//                 </Grid>
//               </Box>
//             </Grid>
//           </>
//         )}

//         {/* Caller Component Section (Always Displayed) */}
//         <Grid
//           item
//           xs={12}
//           sm={4}
//           md={4}
//           style={{
//             position: "fixed",
//             // top: 0,
//             right: 0,
//             width: "300px", // Fixed width for CallerComponent
//             // height: "100vh", // Full height of the viewport
//             // overflowY: "auto",
//             zIndex: 1000, // Ensure it appears on top of other content
//           }}
//         >
//           <CallerComponent
//             tableMobile={tableMobile}
//             setFormOpen={setFormOpen}
//             setFormMobileNo={setFormMobileNo}
//             auditMobNo={mobNo}
//             setAuditMobNum={setAuditMobNum}
//             setOpenSnackbar={setOpenSnackbar}
//             setSeverity={setSeverity}
//             setMessage={setMessage}
//             setCallID={setCallID}
//             missedCallID={missedCallID}
//             setCallType={setCallType}
//           />
//         </Grid>
//       </Grid>

//       <Snackbar
//         open={openSnackbar}
//         autoHideDuration={3000}
//         onClose={handleCloseSnackbar}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//       >
//         <Alert
//           onClose={handleCloseSnackbar}
//           severity={severity}
//           sx={{ width: "100%" }}
//         >
//           {message}
//         </Alert>
//       </Snackbar>
//     </>
//   );
// };

// export default FishFeedDashboardComponent;

import React, { useState, useEffect } from "react";
import axios from "axios";
import ExistingTimelineComponent from "./ExistingTimelineComponent";
import FormComponent from "./FormComponent";
import DateFilterComponent from "./DateFilterComponent";
import { useLocation } from "react-router-dom";
import {
  Alert,
  Box,
  Card,
  CardContent,
  Grid,
  Snackbar,
  Typography,
  Paper,
  Chip,
  IconButton,
  Tooltip,
  Fade,
  CircularProgress,
  useTheme,
  alpha,
} from "@mui/material";
import {
  Phone,
  PhoneCallback,
  Schedule,
  TrendingUp,
  Analytics,
  CallReceived,
  CallMade,
  AccessTime,
  Restaurant,
} from "@mui/icons-material";
import {
  LineChart,
  Line,
  AreaChart,
  Area,
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import CallerComponent from "../../Dialer/callerComponent";
import {
  FISH_FEED_INCOMMING_CALL,
  FISH_FEED_OUTGOING_CALL,
  SHRIMP_LISTING_MASTER,
} from "../../../constants";

// Utility to get date string in YYYY-MM-DD
const getFormattedDate = (date) => date.toISOString().split("T")[0];

// Enhanced Summary Card with animations and icons
const SummaryCard = ({ title, value, subtext, icon, trend, color = "primary" }) => {
  const theme = useTheme();

  return (
    <Fade in timeout={800}>
      <Card
        elevation={0}
        sx={{
          borderRadius: 3,
          padding: 2.5,
          background: `linear-gradient(135deg, ${alpha(theme.palette[color].main, 0.1)}, ${alpha(theme.palette[color].main, 0.05)})`,
          border: `1px solid ${alpha(theme.palette[color].main, 0.2)}`,
          transition: "all 0.3s ease",
          height: "100%",
          position: "relative",
          overflow: "hidden",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: `0 8px 25px ${alpha(theme.palette[color].main, 0.15)}`,
          },
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: 3,
            background: `linear-gradient(90deg, ${theme.palette[color].main}, ${theme.palette[color].light})`,
          },
        }}
      >
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="subtitle2" fontWeight={600} color="text.secondary">
            {title}
          </Typography>
          {icon && (
            <Box
              sx={{
                p: 1,
                borderRadius: 2,
                backgroundColor: alpha(theme.palette[color].main, 0.1),
                color: theme.palette[color].main,
              }}
            >
              {icon}
            </Box>
          )}
        </Box>

        <Box display="flex" alignItems="baseline" gap={1} mb={1}>
          <Typography variant="h4" color={color} fontWeight="bold">
            {value}
          </Typography>
          {trend && (
            <Chip
              size="small"
              label={trend}
              color={trend.includes('+') ? 'success' : 'error'}
              variant="outlined"
              sx={{ fontSize: '0.7rem', height: 20 }}
            />
          )}
        </Box>

        {subtext && (
          <Typography variant="caption" color="text.secondary" fontWeight={500}>
            {subtext}
          </Typography>
        )}
      </Card>
    </Fade>
  );
};

// Chart Card wrapper
const ChartCard = ({ title, subtitle, children, action }) => {
  const theme = useTheme();

  return (
    <Fade in timeout={1000}>
      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: 3,
          border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
          background: "rgba(255, 255, 255, 0.8)",
          backdropFilter: "blur(10px)",
          height: "100%",
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="body2" color="text.secondary">
                {subtitle}
              </Typography>
            )}
          </Box>
          {action}
        </Box>
        {children}
      </Paper>
    </Fade>
  );
};

const FishFeedDashboardComponent = () => {
  const [tableMobile, setTableMobile] = useState("");
  const [formOpen, setFormOpen] = useState(false);
  const [FormMobileNo, setFormMobileNo] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [severity, setSeverity] = useState("");
  const [message, setMessage] = useState("");
  const [callID, setCallID] = useState("");
  const [callType, setCallType] = useState("");
  const [missedCallID, setMissdeCalID] = useState("");
  const [auditMobNum, setAuditMobNum] = useState("");
  const [loading, setLoading] = useState(true);

  const [dateFilter, setDateFilter] = useState('week');
  const [customStartDate, setCustomStartDate] = useState('');
  const [customEndDate, setCustomEndDate] = useState('');
  const [customApplied, setCustomApplied] = useState(false);

  const [incoming, setIncoming] = useState(null);
  const [outgoing, setOutgoing] = useState(null);
  const [shrimp, setShrimp] = useState(null);

  const location = useLocation();
  const { mobNo } = location.state || {};
  const theme = useTheme();

  const getDateRange = (filterType) => {
    const today = new Date();
    let startDate, endDate;

    switch (filterType) {
      case 'today':
        startDate = new Date(today);
        endDate = new Date(today);
        break;
      case 'yesterday':
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        startDate = new Date(yesterday);
        endDate = new Date(yesterday);
        break;
      case 'week':
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 6);
        endDate = new Date(today);
        break;
      case 'month':
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 29);
        endDate = new Date(today);
        break;
      case 'custom':
        startDate = customStartDate ? new Date(customStartDate) : new Date(today);
        endDate = customEndDate ? new Date(customEndDate) : new Date(today);
        break;
      default:
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 6);
        endDate = new Date(today);
    }

    return {
      startDate: getFormattedDate(startDate),
      endDate: getFormattedDate(endDate)
    };
  };

  const { startDate, endDate } = (dateFilter === 'custom' && customApplied)
    ? { startDate: customStartDate, endDate: customEndDate }
    : getDateRange(dateFilter);

  const agent = JSON.parse(localStorage.getItem("userData"));
  const agentNumber = agent?.EmployeePhone;

  const handleFilterChange = (newFilter) => {
    setDateFilter(newFilter);
    if (newFilter !== 'custom') {
      setCustomApplied(false);
    }
  };

  const handleCustomDateChange = (type, value) => {
    if (type === 'start') setCustomStartDate(value);
    if (type === 'end') setCustomEndDate(value);
    setCustomApplied(false);
  };

  const handleApplyCustom = (start, end) => {
    setCustomStartDate(start);
    setCustomEndDate(end);
    setCustomApplied(true);
  };

  useEffect(() => {
    if (dateFilter === 'custom' && !customApplied) return;
    const fetchData = async () => {
      try {
        setLoading(true);
        const [incomingRes, outgoingRes, shrimpRes] = await Promise.all([
          axios.get(
            `${FISH_FEED_INCOMMING_CALL}?startDate=${startDate}&endDate=${endDate}&agentNumber=${agentNumber}`
          ),
          axios.get(
            `${FISH_FEED_OUTGOING_CALL}?startDate=${startDate}&endDate=${endDate}&aPartyNo=${agentNumber}`
          ),
          axios.get(`${SHRIMP_LISTING_MASTER}`),
        ]);
        setIncoming(incomingRes.data);
        setOutgoing(outgoingRes.data);
        setShrimp(shrimpRes.data);
      } catch (error) {
        console.error(error);
        setMessage("Error loading dashboard data");
        setSeverity("error");
        setOpenSnackbar(true);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [dateFilter, agentNumber, startDate, endDate, customApplied]);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenSnackbar(false);
  };

  // Prepare chart data
  const callDistributionData = incoming && outgoing ? [
    { name: 'Incoming', value: incoming.summary.totalCalls, color: theme.palette.primary.main },
    { name: 'Outgoing', value: outgoing.summary.totalCalls, color: theme.palette.secondary.main },
  ] : [];

  const connectionRateData = incoming && outgoing ? [
    {
      name: 'Incoming',
      connected: incoming.summary.connectedCalls,
      missed: incoming.summary.missedCalls,
      total: incoming.summary.totalCalls,
    },
    {
      name: 'Outgoing',
      connected: outgoing.summary.connectedCalls,
      missed: outgoing.summary.missedCalls,
      total: outgoing.summary.totalCalls,
    },
  ] : [];

  // Mock trend data (you can replace with actual historical data)
  const trendData = [
    { day: 'Mon', incoming: 12, outgoing: 8 },
    { day: 'Tue', incoming: 15, outgoing: 10 },
    { day: 'Wed', incoming: 18, outgoing: 12 },
    { day: 'Thu', incoming: 14, outgoing: 9 },
    { day: 'Fri', incoming: 16, outgoing: 11 },
    { day: 'Sat', incoming: 10, outgoing: 7 },
    { day: 'Sun', incoming: 8, outgoing: 5 },
  ];

  // Helper function to get filter display text
  const getFilterDisplayText = () => {
    if (dateFilter === 'custom' && customApplied && customStartDate && customEndDate) {
      return `Custom (${customStartDate} to ${customEndDate})`;
    }
    switch (dateFilter) {
      case 'today':
        return 'Today';
      case 'yesterday':
        return 'Yesterday';
      case 'week':
        return 'Past 7 Days';
      case 'month':
        return 'Past 30 Days';
      default:
        return 'Past 7 Days';
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
        <CircularProgress size={60} thickness={4} />
      </Box>
    );
  }

  return (
    <>
      <Box
        sx={{
          // background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)}, ${alpha(theme.palette.secondary.main, 0.05)})`,
          minHeight: "100vh",
          p: 2,
        }}
      >
        <Grid container spacing={3} style={{ flexWrap: "wrap" }}>
          {formOpen ? (
            <>
              <Grid item xs={12} sm={5} md={5} style={{ flexGrow: 1 }}>
                <ExistingTimelineComponent FormMobileNo={FormMobileNo} />
              </Grid>
              <Grid
                item
                xs={12}
                sm={4}
                md={4}
                style={{ flex: "1 1 350px", minWidth: "300px" }}
              >
                <FormComponent
                  setFormOpen={setFormOpen}
                  setOpenSnackbar={setOpenSnackbar}
                  setSeverity={setSeverity}
                  setMessage={setMessage}
                  FormMobileNo={FormMobileNo}
                  callID={callID}
                  callType={callType}
                />
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={12} md={8}>
                {/* Header Section */}
                <Box sx={{ mb: 4 }}>
                  <Box display="flex" alignItems="center" gap={2} mb={1}>
                    {/* <Restaurant color="primary" sx={{ fontSize: 32 }} /> */}
                    <Typography variant="h4" fontWeight="bold" color="primary">
                      Dashboard
                    </Typography>
                  </Box>
                  <Box display="flex" alignItems="center" gap={1} mb={3}>
                    <Schedule fontSize="small" color="action" />
                    <Typography variant="body1" color="text.secondary">
                      Analytics for {getFilterDisplayText()}: <strong>{startDate}</strong> to <strong>{endDate}</strong>
                    </Typography>
                  </Box>

                  {/* DATE FILTER COMPONENT */}
                  <DateFilterComponent
                    selectedFilter={dateFilter}
                    onFilterChange={handleFilterChange}
                    customStartDate={customStartDate}
                    customEndDate={customEndDate}
                    onCustomDateChange={handleCustomDateChange}
                    onApplyCustom={handleApplyCustom}
                  />
                </Box>

                {/* Key Metrics Cards - Incoming */}
                <Grid container spacing={3} mb={4}>
                  {incoming && (
                    <>
                      <Grid item xs={12} sm={6} md={3}>
                        <SummaryCard
                          title="Incoming Calls"
                          value={incoming.summary.totalCalls}
                          icon={<CallReceived />}
                          color="primary"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <SummaryCard
                          title="Connected (In)"
                          value={incoming.summary.connectedCalls}
                          icon={<Phone />}
                          color="success"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <SummaryCard
                          title="Missed (In)"
                          value={incoming.summary.missedCalls}
                          icon={<PhoneCallback />}
                          color="warning"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <SummaryCard
                          title="Duration (In)"
                          value={incoming.summary.totalDuration}
                          icon={<AccessTime />}
                          color="info"
                        />
                      </Grid>
                    </>
                  )}
                </Grid>

                {/* Key Metrics Cards - Outgoing */}
                <Grid container spacing={3} mb={4}>
                  {outgoing && (
                    <>
                      <Grid item xs={12} sm={6} md={3}>
                        <SummaryCard
                          title="Outgoing Calls"
                          value={outgoing.summary.totalCalls}
                          icon={<CallMade />}
                          color="secondary"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <SummaryCard
                          title="Connected (Out)"
                          value={outgoing.summary.connectedCalls}
                          icon={<Phone />}
                          color="success"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <SummaryCard
                          title="Not Connected"
                          value={outgoing.summary.missedCalls}
                          icon={<PhoneCallback />}
                          color="warning"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <SummaryCard
                          title="Duration (Out)"
                          value={outgoing.summary.totalDuration}
                          icon={<AccessTime />}
                          color="info"
                        />
                      </Grid>
                    </>
                  )}
                </Grid>

                {/* Charts Section */}
                <Grid container spacing={3} mb={4}>
                  {/* Call Distribution Pie Chart */}
                  <Grid item xs={12} md={6}>
                    <ChartCard
                      title="Call Distribution"
                      subtitle="Incoming vs Outgoing calls"
                      action={
                        <Tooltip title="View analytics">
                          <IconButton>
                            <Analytics />
                          </IconButton>
                        </Tooltip>
                      }
                    >
                      <ResponsiveContainer width="100%" height={250}>
                        <PieChart>
                          <Pie
                            data={callDistributionData}
                            cx="50%"
                            cy="50%"
                            outerRadius={80}
                            dataKey="value"
                            label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                          >
                            {callDistributionData.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={entry.color} />
                            ))}
                          </Pie>
                          <RechartsTooltip />
                          <Legend />
                        </PieChart>
                      </ResponsiveContainer>
                    </ChartCard>
                  </Grid>

                  {/* Connection Rate Bar Chart */}
                  <Grid item xs={12} md={6}>
                    <ChartCard
                      title="Connection Analysis"
                      subtitle="Connected vs Missed calls"
                      action={
                        <Tooltip title="View trends">
                          <IconButton>
                            <TrendingUp />
                          </IconButton>
                        </Tooltip>
                      }
                    >
                      <ResponsiveContainer width="100%" height={250}>
                        <BarChart data={connectionRateData}>
                          <CartesianGrid strokeDasharray="3 3" stroke={alpha(theme.palette.divider, 0.3)} />
                          <XAxis dataKey="name" />
                          <YAxis />
                          <RechartsTooltip />
                          <Legend />
                          <Bar dataKey="connected" stackId="a" fill={theme.palette.success.main} name="Connected" />
                          <Bar dataKey="missed" stackId="a" fill={theme.palette.warning.main} name="Missed" />
                        </BarChart>
                      </ResponsiveContainer>
                    </ChartCard>
                  </Grid>

                  {/* Weekly Trend Line Chart */}
                  <Grid item xs={12}>
                    <ChartCard
                      title="Call Trends"
                      subtitle={`Daily call patterns for ${getFilterDisplayText().toLowerCase()}`}
                    >
                      <ResponsiveContainer width="100%" height={300}>
                        <AreaChart data={trendData}>
                          <defs>
                            <linearGradient id="colorIncoming" x1="0" y1="0" x2="0" y2="1">
                              <stop offset="5%" stopColor={theme.palette.primary.main} stopOpacity={0.3} />
                              <stop offset="95%" stopColor={theme.palette.primary.main} stopOpacity={0} />
                            </linearGradient>
                            <linearGradient id="colorOutgoing" x1="0" y1="0" x2="0" y2="1">
                              <stop offset="5%" stopColor={theme.palette.secondary.main} stopOpacity={0.3} />
                              <stop offset="95%" stopColor={theme.palette.secondary.main} stopOpacity={0} />
                            </linearGradient>
                          </defs>
                          <CartesianGrid strokeDasharray="3 3" stroke={alpha(theme.palette.divider, 0.2)} />
                          <XAxis dataKey="day" />
                          <YAxis />
                          <RechartsTooltip />
                          <Legend />
                          <Area
                            type="monotone"
                            dataKey="incoming"
                            stroke={theme.palette.primary.main}
                            fillOpacity={1}
                            fill="url(#colorIncoming)"
                            name="Incoming Calls"
                          />
                          <Area
                            type="monotone"
                            dataKey="outgoing"
                            stroke={theme.palette.secondary.main}
                            fillOpacity={1}
                            fill="url(#colorOutgoing)"
                            name="Outgoing Calls"
                          />
                        </AreaChart>
                      </ResponsiveContainer>
                    </ChartCard>
                  </Grid>
                </Grid>

                {/* Shrimp Feed Section */}
                {/* <Box>
                  <Typography variant="h6" fontWeight="bold" mb={2} display="flex" alignItems="center" gap={1}>
                    <Restaurant color="primary" />
                    Shrimp Feed Details
                  </Typography>
                  <Grid container spacing={3}>
                    {shrimp && (
                      <Grid item xs={12} sm={6} md={3}>
                        <SummaryCard
                          title="Total Records"
                          value={shrimp.data.totalCount}
                          icon={<Analytics />}
                          color="primary"
                        />
                      </Grid>
                    )}
                  </Grid>
                </Box> */}
              </Grid>
            </>
          )}

          {/* Caller Component Section (Always Displayed) */}
          <Grid
            item
            xs={12}
            sm={4}
            md={4}
            style={{
              position: "fixed",
              right: 0,
              width: "300px",
              zIndex: 1000,
            }}
          >
            {(localStorage.getItem("empRole") === "300") && (
              <CallerComponent
                tableMobile={tableMobile}
                setFormOpen={setFormOpen}
                setFormMobileNo={setFormMobileNo}
                auditMobNo={mobNo}
                setAuditMobNum={setAuditMobNum}
                setOpenSnackbar={setOpenSnackbar}
                setSeverity={setSeverity}
                setMessage={setMessage}
                setCallID={setCallID}
                missedCallID={missedCallID}
                setCallType={setCallType}
              />
            )}
          </Grid>
        </Grid>
      </Box>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={severity}
          sx={{
            width: "100%",
            borderRadius: 2,
            backdropFilter: "blur(10px)",
          }}
          variant="filled"
        >
          {message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default FishFeedDashboardComponent;